import React, { useState, useEffect } from "react";
import { FiInfo } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const CookieBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay to make it feel smoother
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (choice) => {
    localStorage.setItem("cookie-consent", choice);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 w-[calc(100%-48px)] max-w-2xl z-[9999] transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
      <div className="bg-white/95 backdrop-blur-xl border border-gray-100 rounded-[32px] p-6 shadow-[0_20px_50px_rgba(0,0,0,0.1)] flex flex-col md:flex-row items-center gap-6">
        <div className="w-14 h-14 bg-orange-50 text-[#ff7a00] rounded-2xl flex-shrink-0 flex items-center justify-center text-2xl">
          <FiInfo />
        </div>
        
        <div className="flex-1 text-center md:text-left">
          <h3 className="text-sm font-black text-[#1d1d1f] mb-1">
            {t("cookies.title", "Cookie Settings")}
          </h3>
          <p className="text-[11px] font-bold text-gray-400 leading-relaxed uppercase tracking-tight">
            {t("cookies.description", "We use cookies to improve your marketplace experience. By continuing, you agree to our data policy.")}
          </p>
        </div>

        <div className="flex items-center gap-3 w-full md:w-auto">
          <button 
            onClick={() => handleConsent("rejected")}
            className="flex-1 md:flex-none px-6 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest text-gray-400 hover:text-gray-600 transition-colors"
          >
            {t("cookies.reject", "Reject")}
          </button>
          <button 
            onClick={() => handleConsent("accepted")}
            className="flex-1 md:flex-none px-8 py-3 bg-[#ff7a00] text-white rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-[0_10px_20px_rgba(255,122,0,0.2)] hover:scale-105 active:scale-95 transition-all"
          >
            {t("cookies.accept", "Accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
